import { Address } from "../../common";
import { VendorPartnerTier } from "../../Vendor/Tiers";

export enum VendorSubscriptionStatus {
	APPLIED = "applied",
	ACCEPTED = "accepted",
	REJECTED = "rejected",
	INVITED = "invited",
	NOTAPPLIED = "not_applied",
	SUSPENDED = "suspended",
	WITHDRAWN = "request_withdrawn"
}

export const JoinedLikeVendorSubscriptionStatus = [
	VendorSubscriptionStatus.ACCEPTED,
	VendorSubscriptionStatus.INVITED
];

export interface VendorCompanyCertification {
	title: string;
	image: string;
	description: string | null;
}

export enum VendorIndustry {
	PROJECT_MANAGEMENT = "project_management",
	SECURITY = "security",
	BUSINESS_PRODUCTIVITY = "business_productivity",
	INFRASTRUCTURE_SOFTWARE = "infrastructure_software",
	SAAS = "saas",
	DATA_PRODUCTS = "data_products",
	IOT = "iot",
	MACHINE_LEARNING = "machine_learning",
	PROFESSIONAL_SERVICES = "professional_services",
	EDUCATION_RESEARCH = "education_research",
	FINANCIAL_SERVICES = "financial_services",
	HEALTHCARE_LIFE_SCIENCE = "healthcare_life_science",
	MEDIA_ENTERTAINMENT = "media_entertainment",
	INDUSTRIAL = "industrial",
	OTHERS = "others"
}

export class VendorCompany {
	created: Date = new Date();
	updated: Date = new Date();
	id = "";
	name = "";
	description = "";
	sub_domain = "";
	twitter_url: string | null = "";
	website_url: string | null = "";
	facebook_url: string | null = "";
	billing_address: Address | null = null;
	favicon: string | null = "";
	logo: string | null = "";
	certifications: VendorCompanyCertification[] =
		new Array<VendorCompanyCertification>();
	industry: VendorIndustry | null = VendorIndustry.SAAS;
	unique_selling_point = "";
	support_email = "";
	support_contact = "";
	status?: VendorSubscriptionStatus;
	tier_with_vendor: VendorPartnerTier | null = null;
	un_suspend_request_time: Date | null = null;
}

export class VendorCompaniesResponse {
	data: VendorCompany[] = new Array<VendorCompany>();
}
export interface UnsuspendVendorRequest {
	reason: string;
}
